import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { syncDocumentLanguage } from './documentLanguage';
import { initI18n } from './setup';

syncDocumentLanguage(i18n);
initI18n(i18n.use(LanguageDetector).use(initReactI18next));

export default i18n;
